import Service from '@ember/service';
import { cached, tracked } from '@glimmer/tracking';
import { registerDestructor } from '@ember/destroyable';
import ApplicationInstance from '@ember/application/instance';
import BsModal from 'ember-bootstrap/components/bs-modal';
import EmptyComponent from 'uplisting-frontend/components/empty-component';

const LARGE_OR_BELOW_QUERY = '(max-width: 1279px)';
// as the SCSS `screen-small` mixin, so layout and behaviour switch together
const SMALL_SCREEN_QUERY = '(max-width: 767px)';

export default class ScreenService extends Service {
  @tracked recalculateMediaQuery = false;

  #largeOrBelowMql = window.matchMedia(LARGE_OR_BELOW_QUERY);
  #smallScreenMql = window.matchMedia(SMALL_SCREEN_QUERY);

  constructor(appInstance: ApplicationInstance) {
    super(appInstance);

    this.#largeOrBelowMql.addEventListener('change', this.#onBreakpointChange);
    this.#smallScreenMql.addEventListener('change', this.#onBreakpointChange);

    registerDestructor(this, () => {
      this.#largeOrBelowMql.removeEventListener(
        'change',
        this.#onBreakpointChange,
      );
      this.#smallScreenMql.removeEventListener(
        'change',
        this.#onBreakpointChange,
      );
    });
  }

  #onBreakpointChange = (): void => {
    this.recalculateMediaQuery = !this.recalculateMediaQuery;
  };

  @cached
  get isLargeOrBelow() {
    // eslint-disable-next-line no-unused-expressions, @typescript-eslint/no-unused-expressions
    this.recalculateMediaQuery;

    return this.#largeOrBelowMql.matches;
  }

  @cached
  get isSmallScreen() {
    // eslint-disable-next-line no-unused-expressions, @typescript-eslint/no-unused-expressions
    this.recalculateMediaQuery;

    return this.#smallScreenMql.matches;
  }

  @cached
  get dropdownMenuComponent(): typeof EmptyComponent | typeof BsModal {
    if (this.isLargeOrBelow) {
      return BsModal;
    }

    return EmptyComponent;
  }
}

declare module '@ember/service' {
  interface Registry {
    screen: ScreenService;
  }
}
